function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "inherti",
  d: "M7.678 1.755a.3.3 0 000-.424L7.042.694a.3.3 0 00-.425 0l-3.11 3.112a.3.3 0 01-.425 0L1.385 2.109a.3.3 0 00-.424 0l-.637.636a.3.3 0 000 .424l2.758 2.758a.3.3 0 00.424 0l4.172-4.172z"
});

function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    width: 8,
    height: 7,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCheckmark;